<template>
  <div>
    <b-container>
      <b-row>
        <b-col>Logout succesfull</b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      token: null
    }
  },
  mounted: function () {
    sessionStorage.removeItem('token')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue